import React from 'react';
import useTheme from 'branding/theme';
import withHover from '../../hocs/withHover';
import CheckboxCircle from '../../graphics/CheckboxCircle';
import ChoiceLabel from '../../typography/ChoiceLabel';
import AccessiblyHiddenChoice from '../AccessiblyHiddenChoice';
import { useWatch } from 'react-hook-form';
import withFocus from '../../hocs/withFocus';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
export const Checkbox = React.forwardRef(({ name, labelText, disabled = false, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleBlur, handleFocus, onBlur, onChange, styles }, ref) => {
    const isChecked = useWatch({ name });
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const { inputs: { choiceStyles } } = useTheme();
    const mergedStyles = {
        ...choiceStyles.base,
        ...(!disabled && isHovered && choiceStyles.hovered),
        ...styles
    };
    return (React.createElement("div", { style: mergedStyles, 
        // putting `tabIndex` here would hinder accessibility
        onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: focusHandlers.onFocus, onBlur: focusHandlers.onBlur },
        React.createElement(AccessiblyHiddenChoice, { name: name, type: "checkbox", disabled: disabled, isHovered: isHovered, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleBlur: handleBlur, onChange: onChange, ref: ref, ...focusHandlers }),
        React.createElement(CheckboxCircle, { isChecked: isChecked, isFocused: isFocused, isHovered: isHovered, disabled: disabled }),
        React.createElement(ChoiceLabel, { htmlFor: name, disabled: disabled }, labelText)));
});
export default withHover(withFocus(withFormProps(Checkbox)));
//# sourceMappingURL=index.js.map